import React,{useState,useEffect} from 'react';
import DefaultHeader from '../Layout/DefaultHeader';
import Navbar1 from '../Layout/Navbar1';
import Card from './Card/Card';
import axios from 'axios';
import {Link} from 'react-router-dom';
import classes from './ListProduct.module.css';
import Spinner from '../Spinner/Spinner';

function ListProBySort(props) {
    const [products, setProducts] = useState([]);
    const [categories, setCategories] = useState([]);
    const [cateName,setCateName]=useState('');
    const [loading,setLoading] =useState(true);
    const catId = props.match.params.cateId;
    const catName =()=> {
        axios.get(`/category/one/${catId}`)
        .then(cate=>setCateName(cate.data.cate))
        .catch(err=>console.log(err))
    }
    const fetchProducts=(catId)=>{  
        axios.get(`/category/${catId}`)
        .then(pro=>{
            setProducts(pro.data.pro);
            setLoading(false);
        }).catch(err=>console.log(err));
    };
    const getCategorys =()=>{
        axios.get('/categorys')
            .then(cats=>{
             setCategories(cats.data.cates);
            }).catch(err=>{
               console.log(err);
            });

    };
    useEffect(()=>{
        fetchProducts(catId);
        getCategorys();
        catName();
    },[props]);


    const showSideBar =()=>(
        <div className={`card ${classes.Card}`}>
                {/* <h4 className="card-header">Category</h4> */}
                <ul className="list-group">
                        {categories.map((cat,i)=>(
                    <li key={i} className="list-group-item">
                        <Link  className="nav-link" to={`/category/${cat._id}`}>
                            {cat.name}
                        </Link>
                    </li>

                        ))}
                </ul>
        </div>
    )

    return (
        <React.Fragment>
            <Navbar1/>
            <DefaultHeader/>
            <br/>
            <div className="row">
                <div className={`${classes.Sidebar} col-md-3`}>
                  
                   {showSideBar()}
                </div>
                <div className="col-md-9">
                        <h2 className="mb-4">{cateName.name}</h2>
                        {(loading&&(<Spinner/>))||(
                        <div className="row">
                            {products.map((product, i) => (
                                <div key={i} className="col-sm-3 mb-3">
                                    <Card  product={product} />
                                </div>
                            ))}
                        </div>

                        )}
                        </div>
                        </div>
        
                    </React.Fragment>
    );
}

export default ListProBySort;